(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPsFaq(section) {
    var buttons = section.querySelectorAll('.ps-faq-q');
    var list = section.querySelector('.ps-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ps-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.ps-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.ps-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pupsnug-faq').forEach(initPsFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.pupsnug-faq');
    if (el) initPsFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPsQuoteCarousel(section) {
    if (section.dataset.psQuoteInitialized) return;
    section.dataset.psQuoteInitialized = '1';

    var track   = section.querySelector('[data-ps-quote-track]');
    var cards   = section.querySelectorAll('[data-ps-quote-card]');
    var prevBtn = section.querySelector('[data-ps-quote-prev]');
    var nextBtn = section.querySelector('[data-ps-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ps-quote-section]').forEach(initPsQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-ps-quote-section]');
    if (!sectionEl) return;
    delete sectionEl.dataset.psQuoteInitialized;
    initPsQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPsCarousel(section) {
    if (section.dataset.psInitialized) return;
    section.dataset.psInitialized = '1';

    var track   = section.querySelector('[data-ps-track]');
    var cards   = section.querySelectorAll('[data-ps-card]');
    var prevBtn = section.querySelector('[data-ps-prev]');
    var nextBtn = section.querySelector('[data-ps-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ps-section]').forEach(initPsCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-ps-section]');
    if (!sectionEl) return;
    delete sectionEl.dataset.psInitialized;
    initPsCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
